<template>
  <b-sidebar
    id="sidebar"
    no-header
    no-header-close
    no-close-on-backdrop
    no-close-on-esc
    no-close-on-route-change
    class="mc-sidebar-liveview mc-sidebar-trackvideo"
    :class="{
      'close-history-sidebar': $store.state.map.modalFleetHistory === true,
      '': $store.state.map.modalFleetHistory === false,
    }"
  >
    <span class="mc-sidebar-toggle" @click="toggleSideBar">
      <i class="mc-fa fas fa-angle-left"></i>
      <i class="mc-fa icon-outline_close"></i>
      <u></u>
    </span>

    <div class="mc-sidebar-liveview__wrapper mc-sidebar-trackvideo__wrapper">
      <ListFleet ref="listFleet" />
    </div>
  </b-sidebar>
</template>

<script>
import ListFleet from './Fleets/ListFleet'
import responsive from '@/mixin/responsive'

export default {
  name: 'SideBar',
  components: {
    ListFleet,
  },
  mixins: [responsive],
  created() {
    if (this.mediaQuery.matches && this.$store.state.sidebar.sideBarOpen) {
      this.toggleSideBar()
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.commit('sidebar/toggleSideBar')
      if (this.mediaQuery.matches) {
        this.$store.dispatch('map/closeInfo', false)
      }
    },
  },
}
</script>
